import type {GetSearchMilestonesRequest} from './api/api-get-search-milestones'

const itemPickerQueryKeyBase = 'item_picker'

export function buildItemPickerMilestoneSearchQueryKey(searchParams: GetSearchMilestonesRequest) {
  return [itemPickerQueryKeyBase, 'milestones', searchParams]
}
